/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export type DataDialogPromptStatus =
  'active' | 
  'deleted'


export function DataDialogPromptStatusFromJSON(json: any): DataDialogPromptStatus {
    return DataDialogPromptStatusFromJSONTyped(json, false);
}

export function DataDialogPromptStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataDialogPromptStatus {
    return json as DataDialogPromptStatus;
}

export function DataDialogPromptStatusToJSON(value?: DataDialogPromptStatus | null): any {
    return value as any;
}

